/**
 * Front-end behavior for offbeat/press-marquee-block.
 *
 * Duplicates the logo track so the CSS translateX(-50%) loop is seamless, then
 * derives the animation duration from the author's pixels-per-second speed and
 * the measured single-track width. Optionally pauses the scroll on hover.
 */
document.addEventListener( 'DOMContentLoaded', function () {
	var blocks = document.querySelectorAll( '.offbeat-press-marquee' );

	blocks.forEach( function ( block ) {
		var track = block.querySelector( '.offbeat-press-marquee__track' );
		if ( ! track || ! track.children.length ) {
			return;
		}

		var speed = parseInt( block.getAttribute( 'data-speed' ), 10 ) || 40;
		var pauseOnHover = block.getAttribute( 'data-pause-on-hover' ) === 'true';

		var singleWidth = track.scrollWidth;

		var clone = track.cloneNode( true );
		clone.setAttribute( 'aria-hidden', 'true' );
		Array.prototype.forEach.call( clone.children, function ( child ) {
			track.appendChild( child.cloneNode( true ) );
		} );

		function applyDuration() {
			var width = track.scrollWidth / 2;
			if ( ! width ) {
				return;
			}
			track.style.animationDuration = width / speed + 's';
		}

		applyDuration();

		var images = track.querySelectorAll( 'img' );
		images.forEach( function ( img ) {
			if ( ! img.complete ) {
				img.addEventListener( 'load', applyDuration );
				img.addEventListener( 'error', applyDuration );
			}
		} );

		window.addEventListener( 'resize', applyDuration );

		if ( pauseOnHover ) {
			block.addEventListener( 'mouseenter', function () {
				block.classList.add( 'is-paused' );
			} );
			block.addEventListener( 'mouseleave', function () {
				block.classList.remove( 'is-paused' );
			} );
		}
	} );
} );
